import React, { useContext } from 'react'
import { FontAwesome } from '../data/FontAwesome';
import { AppContext } from '../AppContext';
import lenovoM8Image from '../images/lenovo-m8-tab.jpg'
import lenovoM10Image from '../images/lenovo-m10-tab.jpg'
import zakatTrackerLogo from '../images/zakat-tracker-logo.png'

export default function About() {
    const { t } = useContext(AppContext)

    return (
        <div>

            {t('about.greeting')}
            <p></p>
            {t('about.intro')}
            <p></p>

            <div className='d-flex flex-column gap-2'>
                <div className='d-flex flex-row'>
                    <div className='mx-1'>{FontAwesome.Check}</div>
                    <div>{t('about.free')}</div>
                </div>

                <div className='d-flex flex-row'>
                    <div className='mx-1'>{FontAwesome.Check}</div>
                    <div>{t('about.noSignup')}</div>
                </div>

                <div className='d-flex flex-row'>
                    <div className='mx-1'>{FontAwesome.Check}</div>
                    <div>{t('about.offline')}</div>
                </div>

            </div>

            <p></p>

            <div className='badge bg-warning text-dark'>{t('about.androidTitle')}</div>
            <div className='ps-1 mt-1'>
                {t('about.androidBody')}
            </div>

            <p></p>

            <div className='badge bg-warning text-dark'>{t('about.echoTitle')}</div>
            <div className='ps-1 mt-1'>
                {t('about.echoBody')}
            </div>

            <div className='rtl fs-5 text-center mt-4 bg-success rounded p-2'>
                الحمد لله والشكر لله، أزكى صلاتي وسلامي على رسول الله وآله وصحبه أجمعين
            </div>
            <p></p>
            {
                navigator.onLine ? (
                    <div className='card p-0'>
                        <div className='card-body px-2 ps-2 pb-0'>

                            <div className='d-flex flex-row align-items-start'>

                                <div className='text-start flex-grow-1'>
                                    <div className='badge text-dark'>{t('about.deviceSuggestions')}</div>

                                    <a className='badge text-dark' href="https://www.google.com/search?tbm=shop&q=amazon+echo+show" target="_blank">
                                        Amazon Echo Show
                                    </a>
                                    <a className='badge text-dark' href="https://www.google.com/search?tbm=shop&q=lenovo+m8+smart+tab" target="_blank">
                                        Lenovo M8
                                    </a>
                                    <a className='badge text-dark' href="https://www.google.com/search?tbm=shop&q=lenovo+m10+smart+dock" target="_blank">
                                        Lenovo M10
                                    </a>
                                </div>
                                <div className='text-center'>
                                    <a href="https://www.google.com/search?tbm=shop&q=lenovo+m8+smart+tab" target="_blank">
                                        <img src={lenovoM8Image} className="img-fluid" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            <p></p>

            <a className='d-flex align-items-center gap-3 text-decoration-none rounded p-2 mt-2'
                href="https://zakattracker.com/?ac" target="_blank" rel="noreferrer"
                style={{ backgroundColor: 'white' }}>
                <img src={zakatTrackerLogo} alt="Zakat Tracker" width="44" height="44" className="rounded" />
                <div>
                    <div className='fw-bold text-dark'>ZakatTracker.com</div>
                    <div className='text-muted small'>{t('about.zakatText')}</div>
                </div>
            </a>

            <div className='d-flex flex-row justify-content-between gap-1 align-items-center mt-4'>
                <div>
                    <a className='whiteLink fs-3' title={t('about.privacy')} href="/privacy-policy/" rel="noreferrer">{FontAwesome.Shield}</a>
                </div>
                <div>
                    <a className='whiteLink fs-3' title={t('about.source')} href="https://github.com/azanclock/pwa" rel="noreferrer">{FontAwesome.Github}</a>
                </div>
                <div>
                    <a className='whiteLink fs-3' title={t('about.chrome')} href="https://chrome.google.com/webstore/detail/prayer-times-chrome-exten/fbkmgnkliklgbmanjkmiihkdioepnkce">{FontAwesome.Chrome}</a>
                </div>
                <div>
                    <a className='whiteLink fs-3' title='info@azanclock.com' href="mailto:info@azanclock.com">{FontAwesome.Envelope}</a>
                </div>
            </div>

            <p></p>

        </div>
    )
}

